module.exports = __webpack_public_path__ + "img/smoke8.3f420bce.png";